import ReactOnRails from 'react-on-rails/client';
import Home from '../../bundles/Home/components/Home.client.jsx';

ReactOnRails.register({Home});